/**
 * @file Web Galleries Blog Post View.
 */

import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import WebGalleryHeaderContainer from '../containers/WebGalleryHeaderContainer';
import WebGalleryBlogPostContainer from '../containers/WebGalleryBlogPostContainer';
import Footer from '../../../components/global/Footer';

const WebGalleriesBlogPostView = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Blog &ndash; Waldo</title>
      </Helmet>

      <div className="wrapper-main">
        <WebGalleryHeaderContainer />
        <WebGalleryBlogPostContainer />
        <Footer />
      </div>
    </Fragment>
  );
};

export default WebGalleriesBlogPostView;
